import { getAllMapsParams } from "features/comments/helpers";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getCustomerFeedbackStagesIds, getStageCustomerFeedback } from "redux/memoizedSelectors";
import { SideModal } from "shared/cx-components/cx-components.style";
import Header from "shared/cx-components/header";
import HeaderTitle from "shared/cx-components/header-title";
import { ItemProvider, useItem } from "shared/dynamic-imports";
import { decode } from "utils/helpers";
import { upsertCustomerFeedback } from "../../reducer/CJMActions";
import DetailFeedBackConfiguration from "./components/detail-feedback-configuration";
import DetailPanelFeedBack from "./components/detail-panel-feedback";
import { connectorInit } from "features/integrations/reducer/ConnectorAction";
import { useEffect } from "react";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    customerFeedbackId?: string[];
    stageId?: string;
};
export default function EditFeedbackData(props: Props): JSX.Element {
    const { isOpen, onClose, stageId, customerFeedbackId } = props;
    const {  personaIdStr, cjmIdStr: cjmId  } = getAllMapsParams(useLocation().search);
    const dispatch = useDispatch();

    const currentItem = useSelector(getStageCustomerFeedback(stageId, personaIdStr))?.getById(customerFeedbackId) || {};
    useEffect(() => {
      
        dispatch(connectorInit({refreshSurveys: true}));
    }, []);
    const handleUpdateFeedbackData = ({ item, modifiedAttribNames }: any) => {
        if (modifiedAttribNames?.includes("description")) item.description = decode(item?.description);
        if (modifiedAttribNames?.includes("name")) item.name = decode(item?.name);
        if (modifiedAttribNames?.includes("sourceDescription")) item.sourceDescription = decode(item?.sourceDescription);

        upsertCustomerFeedback({ 
            customerFeedback: {...currentItem,
                [modifiedAttribNames[0]]: item[modifiedAttribNames[0]]
            }, 
            cjmId: cjmId, modifiedAttribNames 
        })
    };

    return (
        <SideModal show={isOpen} onHide={onClose} scroll backdrop placement="end" container={document.getElementById("modal-root")}>
            {customerFeedbackId ? (
                <div>
                    <ItemProvider initialAction={currentItem} updateService={handleUpdateFeedbackData}>
                        <Content {...props} />
                    </ItemProvider>
                </div>
            ) : null}
        </SideModal>
    );
}
const Content = (props: Props) => {
    const { t } = useTranslation();

    const { onClose, stageId ,customerFeedbackId} = props;
    const { currentItem, setCurrentItem } = useItem();
    const stagesCustomerFeedbackIds = useSelector(getCustomerFeedbackStagesIds(stageId, currentItem?.personaId));
    const customerFeedbacks = useSelector(getStageCustomerFeedback(stageId, currentItem?.personaId));
    const updateCurrentItem = (feedbackId: string) => {
        setCurrentItem(customerFeedbacks?.getById(feedbackId))
    }

    return (
        <>
            <Header
                onClose={onClose}
                navigationList={stagesCustomerFeedbackIds}
                currentItemId={currentItem.id}
                setCurrentItem={updateCurrentItem}
                actions={[]}
                showCopyUrl={false}
                disabled={false}
            />
            <HeaderTitle icon="chart-simple-horizontal" labelPlaceholder={t("FEEDBACK_DATA")} />
            <DetailPanelFeedBack />
            <DetailFeedBackConfiguration customerFeedbackId={customerFeedbackId} stageId={stageId} onClose={onClose} />
        </>
    );
};